import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Row, Column } from 'components/shared/Layout';

import { hotelsShape } from 'constants/propTypes';
import Hotel from 'pages/BookingDetails/Extras/ExtrasHotel/Hotel';

import CancelHotel from '../CancelHotel';

import { ExtraTitle } from '../Refunds.styles';

const CancelExtras = ({ hotels, bookingReference, isPackage }) => {
  const nonCancelledHotels = hotels.filter((h) => !h.cancelled || h.provisional);
  if (!nonCancelledHotels.length) {
    return null;
  }

  return (
    <Row span={14}>
      <Column start={1} span={15}>
        <>
          {nonCancelledHotels.length > 0 && (
            <ExtraTitle>
              <FormattedMessage id="extras.hotel.title" />
            </ExtraTitle>
          )}
          {nonCancelledHotels.map((hotel) => (
            <Hotel key={hotel.itemRef} hotel={hotel} bookingReference={bookingReference} canExchange={false}>
              {!hotel.canBeCancelledOnThirdParty && <CancelHotel hotel={hotel} bookingReference={bookingReference} isPackage={isPackage} />}
            </Hotel>
          ))}
        </>
      </Column>
    </Row>
  );
};

CancelExtras.propTypes = {
  hotels: hotelsShape.isRequired,
  bookingReference: PropTypes.string.isRequired,
  isPackage: PropTypes.bool.isRequired
};

export default CancelExtras;
